import axios from 'axios'

const API_BASE = process.env.REACT_APP_API_URL || 'http://160.251.182.32/api'

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
})

// リクエスト時にJWTトークンを自動付与
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 401エラー時に自動ログアウト
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// 認証
export const authApi = {
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }),
  register: (email: string, name: string, password: string) =>
    api.post('/auth/register', { email, name, password }),
  getMe: () => api.get('/auth/me')
}

// 予約
export const reservationApi = {
  getAvailability: (date: string) =>
    api.get('/reservations/availability', { params: { date } }),
  create: (data: any) => api.post('/reservations', data),
  getById: (id: string) => api.get(`/reservations/${id}`),
  cancel: (id: string) => api.delete(`/reservations/${id}`),
  getAll: (params?: any) => api.get('/reservations', { params }),
  cancelByToken: (token: string) => api.delete(`/reservations/guest/${token}`)
}

// ドア操作
export const doorApi = {
  getStatus: () => api.get('/door/status'),
  lock: () => api.post('/door/lock'),
  unlock: () => api.post('/door/unlock')
}

// ログ
export const logApi = {
  getLogs: (params?: any) => api.get('/logs', { params }),
  exportCsv: () => api.get('/logs/export', { responseType: 'blob' })
}

export default api
